import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card skin-card-haves mb-3"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-title" }

import { computed } from "vue";
import { Retiree } from '@/guiide/ts/retiree';
import { StatePensionDescriptionInfo, retireeDescriber } from '@/guiide/ts/retireeDescriber';

type AssetInfo = { title: string, assetItems: string[] };


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatYouHave',
  props: {
    retiree: {
        type: Object as () => Retiree | null,
        default: () => null,
    },
},
  setup(__props) {

const props = __props;

const statePensionDescriptionInfo = computed<StatePensionDescriptionInfo>(() => retireeDescriber.statePensionDescription());

const hasAnyAssets = computed<boolean>(() => {
    for (const assetGroup of assetGroups.value) {
        if (assetGroup.assetItems.length > 0) {
            return true;
        }
    }
    return false;
});

const assetGroups = computed<Array<AssetInfo>>(() => {
    const assetGroups: AssetInfo[] = Array<AssetInfo>();
    
    if (statePensionDescriptionInfo.value.amount) {
        assetGroups.push({ title: "State Pension", assetItems: [ statePensionDescriptionInfo.value.description ] });
    }

    assetGroups.push({ title: "Pension pots", assetItems: props.retiree?.pensionPots.pots.map(s => s.description) ?? []});
    assetGroups.push({ title: "Final salary pensions", assetItems: props.retiree?.finalSalaries.assets.map(fs => fs.description) ?? []});
    assetGroups.push({ title: "Savings and investment pots", assetItems: props.retiree?.savingsPots.pots.map(s => s.description) ?? []});
    assetGroups.push({ title: "Other cash", assetItems: props.retiree?.otherCash.map(fs => fs.description) ?? []});
    assetGroups.push({ title: "Any other income", assetItems: props.retiree?.otherIncome.map(fs => fs.description) ?? []});

    return assetGroups;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "mt-3 mb-3" }, "What you have to put towards it", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetGroups.value, (assetGroup, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (assetGroup.assetItems.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h5", _hoisted_3, _toDisplayString(assetGroup.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetGroup.assetItems, (assetItem, j) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: j,
                    class: "list-group-item"
                  }, _toDisplayString(assetItem), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 64))
}
}

})